// src/services/managers/AddressManager.js
import userAxios from "../../utils/userAxios";

const BASE_URL = "/address"; // relative to /api

const AddressManager = {
  // ✅ Add or update address
  async addOrUpdateAddress(userId, address) {
    const response = await userAxios.post(`${BASE_URL}/${userId}`, address);
    return response.data;
  },

  // ✅ Get address for a user
  async getAddress(userId) {
    const response = await userAxios.get(`${BASE_URL}/${userId}`);
    return response.data;
  },
};

export default AddressManager;
